import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";


class SearchProduct extends Component {

    constructor(props) {
        super(props);

        this.state = {
            code: ""
        };
    }

    render() {
        return (
            <Form onSubmit={() => {
                this.props.onSearch(this.state.code);
            }}>
                <Form.Input size='big' icon='search' placeholder='Search...'
                            label={this.props.translate("tools.fields.code")}
                            value={this.state.codeOld}
                            onChange={(e) => {
                                this.setState({ code: e.target.value });
                            }}/>
                <Button fluid size='big' positive
                        type='submit'>{this.props.translate("general.search")}</Button>
            </Form>
        );
    }
}

const mapStateToProps = state => ({
    translate: getTranslate(state.localize)
});


const mapDispatchToProps = (dispatch) => {
    return ({});
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchProduct);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/SearchProduct/index.js